<template>
  <div class="panel-body" v-if="planCredit">
    <h4>Plan & Quotas <span style="font-size: 14px;font-weight: normal">(per month)</span></h4>

    <div class="row" style="margin-top: 25px">
      <div class="col-xs-6">
        <div class="form-group clearfix">
          <label class="col-sm-6 control-label">Current plan</label>
          <div class="col-sm-6">
            {{planCredit.plan.name}}
          </div>
        </div>
      </div>
      <div class="col-xs-6">
        <div class="form-group clearfix">
          <label class="col-sm-6 control-label" v-if="!$user.isSme() || (subscription && subscription.cancel_at_period_end === true)">Expiry date</label>
          <div class="col-sm-6">
            <template v-if="subscription && subscription.cancel_at_period_end === true">
              {{subscription.current_period_end | moment('LL')}}
            </template>
            <template v-else-if="!$user.isSme()">
              {{planCredit.expired_at | moment('LL')}}
            </template>
          </div>
        </div>
      </div>

    </div>

    <div class="row" style="margin-top: 0px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Science search</label>

          <div class="col-sm-9">
            <template v-if="planCredit.plan.nb_science_search === -1 || $user.isBasic()">
              Unlimited
            </template>
            <template v-else-if="planCredit.plan.nb_science_search === 0">
              <div><i class="fa fa-warning" style="margin-right: 20px"></i> Not included in your offer</div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-1">
                  {{science_search_consumed}}
                </div>
                <div class="col-xs-10">
                  <div class="progress full">
                    <div :style="{width: science_search_consumed_percentage + '%'}" aria-valuemax="100" aria-valuemin="0"
                         aria-valuenow="75" role="progressbar" class="progress-bar" :class="getClassProgressBar(science_search_consumed_percentage)">
                      {{science_search_consumed_percentage}}%
                    </div>
                  </div>
                </div>
                <div class="col-xs-1">
                  {{planCredit.plan.nb_science_search}}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 0px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Patent search</label>

          <div class="col-sm-9">
            <template v-if="planCredit.plan.nb_patent_search === -1">
              Unlimited
            </template>
            <template v-else-if="planCredit.plan.nb_patent_search === 0">
              <div><i class="fa fa-warning" style="margin-right: 20px"></i> Not included in your offer</div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-1">
                  {{patent_search_consumed}}
                </div>
                <div class="col-xs-10">
                  <div class="progress full">
                    <div :style="{width: patent_search_consumed_percentage + '%'}" aria-valuemax="100" aria-valuemin="0"
                         aria-valuenow="75" role="progressbar" class="progress-bar" :class="getClassProgressBar(patent_search_consumed_percentage)">
                      {{patent_search_consumed_percentage}}%
                    </div>
                  </div>
                </div>
                <div class="col-xs-1">
                  {{planCredit.plan.nb_patent_search}}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 0px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Companies search</label>

          <div class="col-sm-9">
            <template v-if="planCredit.plan.nb_company_search === -1">
              Unlimited
            </template>
            <template v-else-if="planCredit.plan.nb_company_search === 0">
              <div><i class="fa fa-warning" style="margin-right: 20px"></i> Not included in your offer</div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-1">
                  {{company_search_consumed}}
                </div>
                <div class="col-xs-10">
                  <div class="progress full">
                    <div :style="{width: company_search_consumed_percentage + '%'}" aria-valuemax="100" aria-valuemin="0"
                         aria-valuenow="75" role="progressbar" class="progress-bar" :class="getClassProgressBar(company_search_consumed_percentage)">
                      {{company_search_consumed_percentage}}%
                    </div>
                  </div>
                </div>
                <div class="col-xs-1">
                  {{planCredit.plan.nb_company_search}}
                </div>

              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 0px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Remaining projects</label>
          <div class="col-sm-9">
            <template v-if="planCredit.plan.nb_project_storage === -1">
              Unlimited
            </template>
            <template v-else-if="planCredit.plan.nb_project_storage === 0">
              <div><i class="fa fa-warning" style="margin-right: 20px"></i> Not included in your offer</div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-1">
                  {{project_storage_consumed}}
                </div>
                <div class="col-xs-10">
                  <div class="progress full">
                    <div :style="{width: project_storage_consumed_percentage + '%'}" aria-valuemax="100" aria-valuemin="0"
                         aria-valuenow="75" role="progressbar" class="progress-bar" :class="getClassProgressBar(project_storage_consumed_percentage)">
                      {{project_storage_consumed_percentage}}%
                    </div>
                  </div>
                </div>
                <div class="col-xs-1">
                  {{planCredit.plan.nb_project_storage}}
                </div>

              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 0px">
      <div class="col-xs-12">
        <div class="form-group clearfix">
          <label class="col-sm-3 control-label">Remaining contact campaigns</label>
          <div class="col-sm-9">
            <template v-if="planCredit.plan.nb_mailing === -1">
              Unlimited
            </template>
            <template v-else-if="planCredit.plan.nb_mailing === 0">
              <div><i class="fa fa-warning" style="margin-right: 20px"></i> Not included in your offer</div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-1">
                  {{mailing_consumed}}
                </div>
                <div class="col-xs-10">
                  <div class="progress full">
                    <div :style="{width: mailing_consumed_percentage + '%'}" aria-valuemax="100" aria-valuemin="0"
                         aria-valuenow="75" role="progressbar" class="progress-bar" :class="getClassProgressBar(mailing_consumed_percentage)">
                      {{mailing_consumed_percentage}}%
                    </div>
                  </div>
                </div>
                <div class="col-xs-1">
                  {{planCredit.plan.nb_mailing}}
                </div>

              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 25px" v-if="$auth.user().profile.id === 3">
      <div class="col-xs-12 text-center">
        <router-link :to="{name: 'Plans'}" class="btn btn-info ">Modify Plan</router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 text-center" style="margin-top: 25px;">
        <a style="color: red;font-style: italic;font-size: 12px" data-toggle="modal" data-target="#showDeleteAccountModal" class="">Delete account</a>
      </div>
    </div>

    <div class="modal fade hmodal-info" id="showDeleteAccountModal" ref="showDeleteAccountModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h3>Do you want to delete your account ?</h3>
          </div>
          <div class="modal-body">
            <h4>The deletion of the account is irreversible, all your data will be deleted</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" @click="deleteAccount">Delete</vue-ladda>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  name: 'Quota',
  components: {VueLadda},
  props: ['planCredit'],
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      science_search_consumed: 0,
      patent_search_consumed: 0,
      company_search_consumed: 0,
      project_storage_consumed: 0,
      mailing_consumed: 0,
      science_search_consumed_percentage: 0,
      patent_search_consumed_percentage: 0,
      company_search_consumed_percentage: 0,
      project_storage_consumed_percentage: 0,
      mailing_consumed_percentage: 0,
      subscription: null
    }
  },
  methods: {
    getClassProgressBar: function (value) {
      let progressBarClass = ''
      if (value < 50) {
        progressBarClass = 'progress-bar-success'
      } else if (value >= 50 && value < 75) {
        progressBarClass = 'progress-bar-warning'
      } else {
        progressBarClass = 'progress-bar-danger'
      }

      return progressBarClass
    },
    init: function () {
      this.science_search_consumed = this.planCredit.plan.nb_science_search - this.planCredit.nb_science_search_remained
      this.patent_search_consumed = this.planCredit.plan.nb_patent_search - this.planCredit.nb_patent_search_remained
      this.company_search_consumed = this.planCredit.plan.nb_company_search - this.planCredit.nb_company_search_remained
      this.project_storage_consumed = this.planCredit.plan.nb_project_storage - this.planCredit.nb_project_storage_remained
      this.mailing_consumed = this.planCredit.plan.nb_mailing - this.planCredit.nb_mailing_remained

      this.science_search_consumed_percentage = Math.trunc(this.science_search_consumed !== 0
        ? (this.science_search_consumed / this.planCredit.plan.nb_science_search) * 100 : 0)

      this.patent_search_consumed_percentage = Math.trunc(this.patent_search_consumed !== 0
        ? (this.patent_search_consumed / this.planCredit.plan.nb_patent_search) * 100 : 0)

      this.company_search_consumed_percentage = Math.trunc(this.company_search_consumed !== 0
        ? (this.company_search_consumed / this.planCredit.plan.nb_company_search) * 100 : 0)

      this.project_storage_consumed_percentage = Math.trunc(this.project_storage_consumed !== 0
        ? (this.project_storage_consumed / this.planCredit.plan.nb_project_storage) * 100 : 0)

      this.mailing_consumed_percentage = Math.trunc(this.mailing_consumed !== 0
        ? (this.mailing_consumed / this.planCredit.plan.nb_mailing) * 100 : 0)
    },
    deleteAccount () {
      this.submit.loading = true
      this.axios.delete('/auth/delete').then((response) => {
        setTimeout(() => {
          this.$auth.logout({
            makeRequest: true,
            redirect: '/user/register',
            success () {
              this.$salesMachine.clearUser()
            },
            error () {
            }
          })
        }, 500)
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'An error occurred, the account cannot be deleted',
          placement: 'bottom-right'
        })
      }).finally(() => {
        $(this.$refs.showDeleteAccountModal).modal('hide')

        this.submit.loading = false
      })
    }
  },
  beforeMount () {
    if (this.$user.isSme()) {
      this.axios.get('payment/subscription').then((response) => {
        this.subscription = response.data
      })
    }
    if (typeof this.planCredit !== 'undefined' && this.planCredit !== null) {
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Quota.vue